/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Sitesettings_Line_N1Inputs */

const vi_sitesettings_line_n1 = /** @type {(inputs: Sitesettings_Line_N1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dòng ${i?.n}`)
};

/**

* @param {Sitesettings_Line_N1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_line_n1 = /** @type {((inputs: Sitesettings_Line_N1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Line_N1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_line_n1(inputs)
});
export { sitesettings_line_n1 as "siteSettings_line_n" }